import { render, staticRenderFns } from "./settings-gradients.vue?vue&type=template&id=8acda82a&"
import script from "./settings-gradients.vue?vue&type=script&lang=js&"
export * from "./settings-gradients.vue?vue&type=script&lang=js&"
import style0 from "./settings-gradients.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports